<script setup>
import {
    ref,
    reactive,
    inject,
    onMounted,
    onUnmounted,
    computed,
} from 'vue';
const lang = localStorage.getItem('langrage');
const langrage = inject('langrage');
//接口获取流量套餐信息
const firstlistPer=ref([]);


// 倒计时状态
const countdown = reactive({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
});

// 活动结束时间
const now = new Date();
const endTime = ref(new Date(now.getFullYear(), 5, 3, 23, 59, 59).getTime());
let countdownTimer = null;

// 更新倒计时
const updateCountdown = () => {
    const now = new Date().getTime();
    const distance = endTime.value - now;

    if (distance < 0) {
        clearInterval(countdownTimer);
        countdown.days = 0;
        countdown.hours = 0;
        countdown.minutes = 0;
        countdown.seconds = 0;
        return;
    }

    countdown.days = Math.floor(distance / (1000 * 60 * 60 * 24));
    countdown.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    countdown.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    countdown.seconds = Math.floor((distance % (1000 * 60)) / 1000);
};
onMounted(() => {
  updateCountdown();
  countdownTimer = setInterval(updateCountdown, 1000);
});
onUnmounted(() => {
    if (countdownTimer) {
        clearInterval(countdownTimer);
    }
});
</script>
<template>
    <div class="promo-banner">
        <span class="promo-tag">🔥 {{langrage.activitytop1}}</span>
        <div class="activityGroup">
           <span class="highlight">{{langrage.activitytop3}}</span>
           <span class="strike">$2.7/GB</span> 
           <span>$0.8/GB</span>
        </div>
        <div class="activityGroup">
           <span class="highlight">{{langrage.activitytop2}}</span>
           <span class="strike">$1.5/GB</span> 
           <span>$0.5/GB</span>
        </div>
        
        <div class="countdownMini">{{langrage.activitytime1}}:</div>
        <div class="countdown-mini">
            <span class="seg">{{ String(countdown.days).padStart(2, '0') }}</span>
            <span class="sep">·</span>
            <span class="seg">{{ String(countdown.hours).padStart(2, '0') }}</span>
            <span class="sep">:</span>
            <span class="seg">{{ String(countdown.minutes).padStart(2, '0') }}</span>
            <span class="sep">:</span>
            <span class="seg">{{ String(countdown.seconds).padStart(2, '0') }}</span>
        </div>
    </div>
</template>
<style scoped lang="less">
    /* ===== 顶部促销横幅 ===== */
    .promo-banner {
        background:
            radial-gradient(ellipse at 20% 50%, rgba(255, 122, 24, 0.25) 0%, transparent 60%),
            radial-gradient(ellipse at 80% 50%, rgba(95, 168, 255, 0.25) 0%, transparent 60%),
            linear-gradient(90deg, var(--space-1) 0%, var(--space-2) 50%, var(--space-1) 100%);
        color: var(--activity-white);
        padding: 0 24px;
        height: 4.5rem;
        line-height: 46px;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0.3px;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 100;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 18px;
        overflow: hidden;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 35%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.12), transparent);
            animation: shimmer 6s linear infinite;
            pointer-events: none;
        }

        .promo-tag {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            background: linear-gradient(135deg, var(--activity-flame) 0%, var(--activity-dark) 100%);
            color: #fff;
            padding: 0 12px;
            height: 26px;
            line-height: 26px;
            border-radius: 13px;
            font-size: 12px;
            font-weight: 700;
            letter-spacing: 0.5px;
            box-shadow: 0 0 12px rgba(255, 122, 24, 0.5);
            z-index: 2;
            position: relative;
        }

        .highlight {
            font-weight: 700;
            z-index: 2;
            position: relative;
        }

        .strike {
            color: rgba(255, 255, 255, 0.45);
            text-decoration: line-through;
            font-weight: 500;
            margin-right: 2px;
            z-index: 2;
            position: relative;
        }

        .countdown-mini {
            display: inline-flex;
            align-items: center;
            gap: 4px;
            z-index: 2;
            position: relative;

            .seg {
                background: rgba(255, 122, 24, 0.18);
                border: 1px solid rgba(255, 179, 113, 0.4);
                color: #ffb371;
                padding: 0 6px;
                min-width: 24px;
                height: 22px;
                line-height: 22px;
                text-align: center;
                border-radius: 4px;
                font-weight: 700;
                font-variant-numeric: tabular-nums;
                font-size: 12px;
            }

            .sep {
                color: var(--activity-flame);
                font-weight: 700;
            }
        }
    }

    @media screen and (max-width: 768px) {
        .promo-banner {
            padding: 0 12px;
            line-height: 40px;
            font-size: 12px;
            gap: 10px;

            .promo-tag {
                
            }

            .countdown-mini .seg {
                min-width: 20px;
                height: 18px;
                line-height: 18px;
                font-size: 11px;
                padding: 0 4px;
            }
            
            .activityGroup{
                display: none;
            }
        }
    }

</style>